/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type LpRebalanceArgs = {
  /** Uses Initializer semantics: buy is quote-to-base and sell is base-to-quote. */
  tradeDirection: number;
  amountIn: bigint;
  minAmountOut: bigint;
};

export type LpRebalanceArgsArgs = {
  /** Uses Initializer semantics: buy is quote-to-base and sell is base-to-quote. */
  tradeDirection: number;
  amountIn: number | bigint;
  minAmountOut: number | bigint;
};

export function getLpRebalanceArgsEncoder(): FixedSizeEncoder<LpRebalanceArgsArgs> {
  return getStructEncoder([
    ['tradeDirection', getU8Encoder()],
    ['amountIn', getU64Encoder()],
    ['minAmountOut', getU64Encoder()],
  ]);
}

export function getLpRebalanceArgsDecoder(): FixedSizeDecoder<LpRebalanceArgs> {
  return getStructDecoder([
    ['tradeDirection', getU8Decoder()],
    ['amountIn', getU64Decoder()],
    ['minAmountOut', getU64Decoder()],
  ]);
}

export function getLpRebalanceArgsCodec(): FixedSizeCodec<
  LpRebalanceArgsArgs,
  LpRebalanceArgs
> {
  return combineCodec(getLpRebalanceArgsEncoder(), getLpRebalanceArgsDecoder());
}
